import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "duration_start",
    type: "date",
    sortable: true,
    searchable: true,
  },
  {
    name: "duration_end",
    type: "date",
    sortable: true,
    searchable: true,
  },
  {
    name: "sale_price",
    type: "money",
    sortable: true,
    searchable: true,
  },
  {
    name: "category",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "categories.name",
  },
  {
    name: "active",
    type: "boolean",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return (
    <ResourceListPage
      url="products"
      columns={columns}
      title="groups"
      baseQuery={{
        type: "COURSE",
      }}
    />
  );
}
